import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import DishManager from './pages/admin/DishManager';
import AllergyManager from './pages/admin/AllergyManager';
import WaiterLogin from './pages/waiter/WaiterLogin';
import WaiterInterface from './pages/waiter/WaiterInterface';
import { KitchenLogin } from './pages/kitchen/KitchenLogin';
import KitchenDisplay from './pages/kitchen/KitchenDisplay';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SocketProvider } from './services/socket';

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <SocketProvider>
        <div className="min-h-screen bg-gray-900 text-white">
          <Routes>
            {/* Landing page with role selection */}
            <Route path="/" element={<Landing />} />

            {/* Admin/Manager routes */}
            <Route path="/admin/*" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="dishes" element={<DishManager />} />
              <Route path="allergies" element={<AllergyManager />} />
            </Route>

            {/* Waiter routes */}
            <Route path="/waiter" element={<WaiterLogin />} />
            <Route path="/waiter/interface" element={<WaiterInterface />} />

            {/* Kitchen routes */}
            <Route path="/kitchen" element={<KitchenLogin />} />
            <Route path="/kitchen/display" element={<KitchenDisplay />} />

            {/* 404 fallback */}
            <Route path="*" element={
              <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-red-400 mb-4">404</h1>
                  <p className="text-gray-300">הדף שחיפשת לא נמצא</p>
                </div>
              </div>
            } />
          </Routes>
        </div>
      </SocketProvider>
    </ErrorBoundary>
  );
};